import ChooseLpaButton from './ChooseLpaButton';

export default ChooseLpaButton;
